export function arrayIncludesAll(collection, requiredItems) {
  return requiredItems.every(v => collection.includes(v));
}
;